import { render, staticRenderFns } from "./CatalogItem.vue?vue&type=template&id=3259a436&"
import script from "./CatalogItem.vue?vue&type=script&lang=js&"
export * from "./CatalogItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports